class Registration {

  static factory($resource, $log, config) {
    return $resource(
      config.registrationResourcePath + '/:id',
      { id: '@id' },
      {
        get: {
          method: 'GET',
          transformResponse: function(data, headers) {
            return angular.fromJson(data).registration
          }
        },
        create: { method: 'POST' },
        update: { method: 'PUT' },
        resend: {
          url: config.registrationResourcePath + '/:id/resend',
          method: 'GET'
        }
      }
    )
  }
}

Registration.factory.$inject = ['$resource', '$log', 'config']

export default Registration
